import { Button, DialogActions, DialogContent, DialogContentText } from '@mui/material'
import DialogBaseCC from 'components/Dialog/DialogBaseCC'
import { DIALOG_ID } from 'components/Dialog/constant'
import { useTranslation } from 'react-i18next'
import { setCloseDialogCC } from 'utils/helpers'

const DialogLimitTotalMeeting = () => {
    const { t } = useTranslation('packageManagement')

    return (
        <DialogBaseCC title={t('dialog.limitMeeting')} id={DIALOG_ID.LIMIT_TOTAL_MEETING} customClose={() => {
            
        }}>
            <DialogContent style={{overflowY: "unset"}}>
                <DialogContentText>
                    <div style={{marginBottom: "8px"}} className="label confirm-delete-dataset">
                        <div style={{marginBottom: "8px"}}>{t('dialog.desLimitMeeting')}</div>
                        <div>{t('dialog.noteLimitMeeting')}</div>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={() => setCloseDialogCC()}>{t('actions.cancel')}</Button>
                <Button onClick={() => setCloseDialogCC()}>{t('actions.understand')}</Button>
            </DialogActions>
        </DialogBaseCC>
    )
}

export default DialogLimitTotalMeeting